import React, { useContext } from 'react';
import cls from 'classnames';
import Bundle from '../../../models/Bundle';
import { BundlePlaceholder } from './BundlePlaceholder';
import { BundleRow } from './BundleRow';
import styles from './bundle_table.module.scss';
import { MultipleProductsBundleRow } from './MultipleProductsBundleRow';
import { useCalculateMonthlyPayment } from './hooks';
import { SalesContext } from '../../../SalesContext';

type Props = {
  disabled?: boolean;
  bundles: Bundle[];
  onBundlesChange: (bundles: Bundle[]) => void;
  onBundleSelect: (bundle: Bundle) => void;
  selectedBundleKey?: string;
};

/**
 * Renders a table of bundles.
*/
export const BundleTable: React.FC<Props> = ({
  disabled,
  bundles,
  onBundlesChange,
  onBundleSelect,
  selectedBundleKey
}) => {

  const { setMonthlyPaymentTotal, monthlyPaymentTotal } = useContext(SalesContext);

  const selectedBundle = bundles.find(({ key }) => key === selectedBundleKey);

  const total = useCalculateMonthlyPayment(bundles);

  if (monthlyPaymentTotal !== total) {
    setMonthlyPaymentTotal(total);
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
      <h2>Köpet avser</h2>
      <table className={cls([
        styles.table,
        !bundles?.length ? styles.empty : null,
        disabled ? styles.disabled : null
      ])}>
        <thead>
          <tr>
            <th>Produktnamn</th>
            <th>Månadsamortering</th>
          </tr>
        </thead>
        <tbody>
          {
            bundles?.length > 0 ? (
                bundles.map((bundle, index) => (
                  <MultipleProductsBundleRow
                    shouldShowMonthlyPayment={bundles.length - 1 === index}
                    key={bundle.key}
                    bundle={bundle}
                    onDelete={() => onBundlesChange(bundles.filter(otherBundle => otherBundle.key !== bundle.key))}
                    selected={bundle.key === selectedBundleKey}
                    onSelect={() => onBundleSelect(bundle)} 
                    monthlyPaymentTotal={monthlyPaymentTotal}
                    />
                ))
            ) : (<tr>
              <td colSpan={6}>
                <BundlePlaceholder />
              </td>
            </tr>)
          }
        </tbody>
      </table>
      {
        bundles?.length && !disabled ? (
          <p className={cls([styles.selectHint, selectedBundle ? styles.selected : null])}>
            {!selectedBundle ? 'Tryck på en rad för att ändra den' : 'Tryck på raden igen för att släppa den'}
          </p>
        ) : null
      }
    </div>
  );
}